
'use strict'
import Auth from "../libs/API/Auth";
class Input{
    
    constructor(input, options = {
        autocomplete: false,
        endpoint: null,
        einPatter: false,
        disallowedChars: []
    }){
        this.allowed = [];
        this._input = input;
        this._options = options;
        this._suggestionList = null;
        this._autocompleteData = [];
        this._clearBtn = null;
        this._formGroup = this._input.closest('.form-group');

        if (this._formGroup) this._clearBtn = this._formGroup.querySelector('.input_clear_btn');

        this._isNumeric = false;
        this._hasError = false;

        this._input.addEventListener('focusout', this._onFocusOut.bind(this));
        this._input.addEventListener('keydown', this._onKeyDown.bind(this));
        if(this._options.autocomplete) this._input.addEventListener('keyup', this._onKeyUp.bind(this));
        this._input.addEventListener('paste', this._onPaste.bind(this));
        this._input.addEventListener('input', this._onInput.bind(this));

        if(this._options.autocomplete && this._options.endpoint!=null){
            this._input.parentNode.classList.add('form-group__input--loading');
            this._input.disabled = true;
            this._setAllBanks(this._options.endpoint).then(()=>{
                this._input.disabled = false;
                this._input.parentNode.classList.remove('form-group__input--loading');
                this._layoutAutocomplete();
            });
        }

        if (this._clearBtn) {
            this._clearBtn.addEventListener('click', this._onClickClearBtn.bind(this));
            this._checkClearBtn();
        }
        
    }
    
    async _setAllBanks(endpoint){
        this._autocompleteData = await this._resultAutocomplete(endpoint);
    }
    
    _layoutAutocomplete(){
        this._suggestionList = document.createElement('div');
        this._suggestionList.className = 'form-input__suggestion';
        this._input.parentNode.insertBefore(this._suggestionList, this._input.nextSibling);
    }
    
    _updateAutocomplete(dataArray){
        this._suggestionList.innerHTML = '';
        let list = document.createElement('ul');
        if(dataArray.length){
            dataArray = dataArray.map((data)=>{
                return data = `<li data-value="${data.name}">${data.name}</li>`;
            });
            list.innerHTML = dataArray.join(' ');
            this._suggestionList.appendChild(list);
        }
    }

    _onFocusOut(e){
        
        if (!this._formGroup) return;
        
        if(this._input.value != '')this._formGroup.classList.add('form-group--filled');
        else this._formGroup.classList.remove('form-group--filled');
    }
    
    
    _onKeyUp(e){
        if(this._options.autocomplete){
            let searchValue = e.target.value;
            let emptyArray = [];
            if (searchValue){
                emptyArray = this._autocompleteData.items.filter((data)=>{
                    return data.name.toLocaleLowerCase().startsWith(searchValue.toLocaleLowerCase()); 
                });
                if(emptyArray.length){
                    this._suggestionList.classList.add('form-input__suggestion--active');
                    this._updateAutocomplete(emptyArray);
    
                    let allList = this._suggestionList.querySelectorAll("li");
                    let _this = this;
                    for (let i = 0; i < allList.length; i++) {
                        allList[i].addEventListener("click", function(e){
                            _this.value = e.currentTarget.dataset.value
                            _this._suggestionList.classList.remove('form-input__suggestion--active');
                        });
                    }
                }

            }else{
                this._suggestionList.classList.remove('form-input__suggestion--active');
            }
        }
    }

    _onKeyDown(e){
        let allowed = [37,39,46];//arrows and supr
        if (this.allowed){
            allowed = allowed.concat(this.allowed);
        }

        if(this._isNumeric && e.keyCode > 31 && !(e.keyCode >= 48 && e.keyCode <= 57) && !(e.keyCode >= 96 && e.keyCode <= 105) && allowed.indexOf(e.keyCode) == -1){
            e.preventDefault();
        }
    }

    async _resultAutocomplete(endpoint,params = {total_results:999}){
        var queryString = Object.keys(params)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&');
        switch (endpoint) {
            case 'banks':
                return await Auth.makePrivateGet(`${BASE_URL}api/banks?${queryString}`);
            default:
                break;
        }
    }

    _onPaste(e){
        if(this._isNumeric && isNaN(e.clipboardData.getData('text'))){
            e.preventDefault();
        }                       
    }

    _onInput(e){
        this.error = false;
        
        const disallowedChars = this._options.disallowedChars;
        if (disallowedChars && disallowedChars.length > 0) {
            // Escape special characters for the regular expression
            const escapedChars = disallowedChars.map(char => `\\${char}`).join('');
            const regex = new RegExp(`[${escapedChars}]`, 'g');
            this._input.value = this._input.value.replace(regex, '');
        }
        if(this._options.einPatter){
            this._input.value = this._input.value.replace(/\D/g, '');
            if (this._input.value.length > 2) {
                this._input.value = this._input.value.slice(0, 2) + '-' + this._input.value.slice(2);
            }
            if (this._input.value.length > 10) {
                this._input.value = this._input.value.slice(0, 10);
            }
        }

        if (this._clearBtn) this._checkClearBtn();
    }

    _onClickClearBtn() {
        this.value = '';
        this.focus();

        const inputEvent = new Event('input', {
            bubbles: true,
            cancelable: true
        });
        this._input.dispatchEvent(inputEvent);
    }

    _checkClearBtn() {
        if (this._input.value.trim() !== '') this._clearBtn.classList.remove('d-none');
        else this._clearBtn.classList.add('d-none');
    }
    
    set error(value){
        this._hasError = value;

        if(value)this._formGroup.classList.add('form-group--error');
        else this._formGroup.classList.remove('form-group--error');
    }

    get hasError(){
        return this._hasError;
    }

    set errorMessage(message){
        this._formGroup.querySelector('.form-message--error .form-message__text').innerHTML = message;
    }

    set value(value){
        this._input.value = value;

        if (!this._formGroup){
          return;
        }
        
        if(this._input.value != "") this._formGroup.classList.add('form-group--filled');
        else this._formGroup.classList.remove('form-group--filled');
    }
    
    get value(){
        return this._input.value.trim();
    }

    set numeric(allowed){
        if (allowed){
            this.allowed = allowed;
        }
        this._isNumeric = true;
    }

    select(){
        this._input.select();
    }

    focus(){
        this._input.focus();
    }

    empty(){
        this._input.value = "";
        this._formGroup.classList.remove('form-group--filled');
    }

    reset(){
        this.empty();
        this.error = false;
    }

    get isEmpty(){
        return this.value.replace(/(^\s*)|(\s*$)|[ ]/g, "").length == 0;
    }

    get isValidEmail(){
        return /^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.value);
    }

    get isValidName(){
        return /^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ\s]+$/.test(this.value);
    }

    get isValidNameNoAccents(){
        return /^[A-Za-z0-9\s-]+$/.test(this.value);
    }

    get isValidUrl(){
        return /^(ftp|http|https):\/\/[^ "]+$/.test(this.value);
    }
    
    /* get isValidPhone(){
        return /^\+?([0-9]{1,14})$/.test(this.value);
    } */


    get input(){
        return this._input;
    }

    addEventListener(event, callback){
        this._input.addEventListener(event, callback);
    }

}

export default Input;
